import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon =
  (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) ??
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ??
  '';

if (!url || !anon) {
  // eslint-disable-next-line no-console
  console.error(
    'VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY (ou VITE_SUPABASE_ANON_KEY) são obrigatórias',
  );
}

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true },
  db: { schema: 'crm' },
});

export const CRM_API_BASE =
  (import.meta.env.VITE_CRM_API_URL as string | undefined) ??
  (import.meta.env.VITE_CRM_API_BASE as string | undefined) ??
  '';
